import React from 'react';
import { isNum } from '../format';

/**
 * Single ratio against a limit. `tone` picks the fill severity; the unfilled
 * track is a lighter step of the same ramp.
 */
export default function Meter({ value, max = 1, tone = 'accent', label, valueLabel }) {
  const pct = isNum(value) ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className={`le-meter le-meter-${tone}`} role="meter" aria-valuemin={0} aria-valuemax={max} aria-valuenow={isNum(value) ? value : undefined} aria-label={label}>
      <div className="le-meter-track">
        <div className="le-meter-fill" style={{ width: `${pct}%` }} />
      </div>
      {valueLabel ? <span className="le-meter-value">{valueLabel}</span> : null}
    </div>
  );
}
